export default {
  '/e/star-bandz-raq-baby-2025-05-18-the-cabooze-minneapolis-5a6dcb': '/e/star-bandz-raq-baby-2025-05-18-the-cabooze-minneapolis-27ddf7',
} as Record<string, string>;
